<template>
  <div class="row result_row">
    <div class="col-3 thumbnail_container">
      <div class="thumbnail_container_inner" @click.stop="$parent.goToProgramGuideDetail(programGuide)">
        <template v-if="programGuide.thumbnailURL">
          <img v-bind:src="programGuide.thumbnailURL"
            alt="Img"
            class="thumb_img"
            onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
        </template>
        <template v-else>
          <div class="default_thumb">
            <span class="ic ic-degreeProgram" style="margin-top: 25px;"></span>
          </div>
        </template>
      </div>

      <div class="more_details">
        <div class="program_desc">
          <b-link v-b-modal="'progDesc_' + programGuide.uuid">more</b-link>

          <b-modal :id="'progDesc_' + programGuide.uuid" :title="programGuide.title" hide-footer>
            <div v-if="$parent.showDescriptionOnResult && programGuide.description" v-html="programGuide.description"></div>
          </b-modal>
        </div>

      </div>

    </div>
    <div class="col-9 entity_details">
      <div class="row entity_title" @click.stop="$parent.goToProgramGuideDetail(programGuide)">
        <div class="title_txt">{{programGuide.title}}</div>
      </div>
      <div @click.stop="$parent.goToProgramGuideDetail(programGuide)">
        <div class="row oth_details" v-if="showCreditInfo(programGuide.code)">
          <div class="label"></div>
          <div class="val"> {{getCreditInfo(programGuide.code).transferred}} out of {{getCreditInfo(programGuide.code).total}} credits</div>

        </div>
        <div v-if="$parent.showMedianIncomeOnResult" class="row oth_details">
          <div class="label">{{$parent.medianIncomeResultLabel}}</div>
          <div class="val" v-if="programGuide.medianIncomePerYear">
            {{$parent.currencyLabel}} <span v-html="$parent.addCommaInNumber(programGuide.medianIncomePerYear)"></span>
          </div>
          <div class="val no_data" v-else>N/A</div>
        </div>
        <div v-if="$parent.showJobPostingsOnResult" class="row oth_details">
          <div class="label">{{$parent.jobPostingsResultLabel}}</div>
          <div  class="val"v-if="programGuide.totalJobPostings">
            <span v-html="$parent.addCommaInNumber(programGuide.totalJobPostings)"></span>
          </div>
          <div class="val no_data" v-else>N/A</div>
        </div>
        <div v-if="$parent.showGrowthRateOnResult" class="row oth_details">
          <div class="label">{{$parent.growthRateResultLabel}}<span class="exclamation-circle" v-popover:tooltip="'Source: BLS. 2016-2026'"><span class="ico-error"></span></span></div>
          <div class="val" v-if="programGuide.growthRate">{{programGuide.growthRate}} %</div>
          <div class="val no_data" v-else>N/A</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'related-program',
  props: ['programGuide', 'sourceProgram'],
  methods: {
      showCreditInfo (rpCode){
          let creditInfo = {}
          for(let i=0;i<this.sourceProgram.relatedProgramsCreditInfo.length;i++){
            creditInfo = this.sourceProgram.relatedProgramsCreditInfo[i]
            if(rpCode === creditInfo.programCode){
              return true
              break
            }
          }
          return  false
      },
      getCreditInfo (rpCode) {
          if(this.sourceProgram.relatedProgramsCreditInfo.length>0){
            for(let i=0;i<this.sourceProgram.relatedProgramsCreditInfo.length;i++){
              let creditInfo = this.sourceProgram.relatedProgramsCreditInfo[i]
              if(rpCode === creditInfo.programCode){
                return creditInfo
                break
              }
            }
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/RelatedProgram.vue